<p>
  <span [innerHTML]="label"></span>
  <strong>
    <ng-content>
    </ng-content>
  </strong>
</p>
